var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFootnote = function SvgFootnote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 10.72-.775-2.375-5.979 1.954V4h-2.492v6.299l-5.98-1.954L4 10.72l5.979 1.954-3.688 5.086 2.02 1.465L12 14.14l3.688 5.086 2.021-1.465-3.688-5.086z"
  })));
};
export default SvgFootnote;